import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";
import { Add } from "@mui/icons-material";

import { ProjectHeader } from "../../components/project";
import { PageLayout } from "../../layouts/PageLayout";
import { useHasPermission } from "../../utils";
import { CREATE_TASK } from "../../constants";
import { AddEditTask, TaskList } from "../../components/task";

export const ProjectTask = () => {
  const [totalCount, setTotalCount] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [reload, setReload] = useState(0);

  const { id } = useParams();
  const hasTaskCreate = useHasPermission(CREATE_TASK);

  const handleReload = () => setReload((prev) => prev + 1);

  const buttons = [
    hasTaskCreate && { icon: <Add />, buttonText: "Add Task", tooltip: "Add Task", onClick: () => setOpenModal(true) },
  ];
  return (
    <>
      <PageLayout>
        <Box sx={{ position: "relative", zIndex: 1, marginTop: "22px" }}>
          <ProjectHeader title="Project Tasks" actionButtons={buttons} />
        </Box>
        <TaskList totalCount={totalCount} setTotalCount={setTotalCount} reloadData={reload} projectId={id} />
      </PageLayout>

      {/* add task */}
      <AddEditTask open={openModal} projectId={id} onClose={() => setOpenModal(false)} onSuccess={handleReload} />
    </>
  );
};
